import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchProjectBusPrioritysSuccess,
    showProjectBusPriorityMessage,
    onSaveProjectBusPrioritySuccess,
    onDeleteProjectBusPrioritySuccess,
    addFavouriteProjectBusPrioritySuccess,
} from 'actions/projectBusPriority';
import {
    ON_SAVE_PROJECT_BUS_PRIORITY,
    FETCH_ALL_PROJECT_BUS_PRIORITY,
    ON_DELETE_PROJECT_BUS_PRIORITY,
    ADD_FAVOURITE_PROJECT_BUS_PRIORITY,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getProjectBusPriorityList = (state) => state.projectBusPrioritys.allProjectBusPriority;

export function* fetchProjectBusPrioritys() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedProjectBusPrioritys = yield call(
            fetchDataRequest,
            'projectBusPrioritys',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchProjectBusPrioritysSuccess(fetchedProjectBusPrioritys));
    } catch (error) {
        yield put(showProjectBusPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteProjectBusPriority({ payload }) {
    try {
        // payload should be the projectBusPriorityId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteProjectBusPriority',
            'Deleting projectBusPriority '.concat(payload),
            [ORGID_PATH_PARAM, 'projectBusPriorityId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeleteProjectBusPrioritySuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showProjectBusPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveProjectBusPriority({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allProjectBusPrioritys = yield select(getProjectBusPriorityList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload ?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedProjectBusPriority = yield call(
            addOrUpdateDataRequest,
            allProjectBusPrioritys,
            finalPayload,
            'addProjectBusPriority',
            'updateProjectBusPriority',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveProjectBusPrioritySuccess(savedProjectBusPriority));
    } catch (error) {
        yield put(showProjectBusPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteProjectBusPriority({ payload }) {
    try {
        const allProjectBusPrioritys = yield select(getProjectBusPriorityList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allProjectBusPrioritys.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedProjectBusPriority = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedProjectBusPriority ?.starred).concat(' for projectBusPriority ').concat(updatedProjectBusPriority ?.id);
            yield call(
                updateDataRequest,
                updatedProjectBusPriority,
                'updateProjectBusPriority',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteProjectBusPrioritySuccess(payload));
        }
    } catch (error) {
        yield put(showProjectBusPriorityMessage(error.messages));
    }
}

export function* fetchProjectBusPrioritysSaga() {
    yield takeEvery(FETCH_ALL_PROJECT_BUS_PRIORITY, fetchProjectBusPrioritys);
}

export function* saveProjectBusPrioritySaga() {
    yield takeEvery(ON_SAVE_PROJECT_BUS_PRIORITY, saveProjectBusPriority);
}

export function* deleteProjectBusPrioritySaga() {
    yield takeEvery(ON_DELETE_PROJECT_BUS_PRIORITY, deleteProjectBusPriority);
}

export function* addFavouriteProjectBusPrioritySaga() {
    yield takeEvery(ADD_FAVOURITE_PROJECT_BUS_PRIORITY, addFavouriteProjectBusPriority);
}

export default function* rootSaga() {
    yield all([
        fork(fetchProjectBusPrioritysSaga),
        fork(saveProjectBusPrioritySaga),
        fork(deleteProjectBusPrioritySaga),
        fork(addFavouriteProjectBusPrioritySaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/projectBusPriority.js